import * as _ from 'lodash';
import toastr from 'toastr';
import ApiService from '../../../../service/apiService';
import logUtils from '../../../../HelperMethods/LogUtils';
import {
  loadPicklistMapping,
  setFormLoader,
  setLoader,
  upsertPicklistMapping,
  deletePicklistMapping as deletePicklistFromRedux,
} from './reducer';

export function loadAllPicklistMappings() {
  return async (dispatch) => {
    dispatch(setLoader(true));
    try {
      const allPicklistMappings = await ApiService.getAllPicklistMappings();
      dispatch(loadPicklistMapping(allPicklistMappings));
    } catch (e) {
      dispatch(loadPicklistMapping([]));
      logUtils.logError(e, 'Loading Picklist Mappings Failed');
    } finally {
      dispatch(setLoader(false));
    }
  };
}

export function updatePicklistMapping(picklistMapping) {
  return async (dispatch) => {
    dispatch(setFormLoader(true));
    try {
      const updatedPicklistMapping = await ApiService.upsertPicklistMapping(picklistMapping);
      if (!updatedPicklistMapping) throw new Error('Didnt receive updated Picklist Mapping from api');
      toastr.success('Picklist Mapping updated');
      dispatch(upsertPicklistMapping(updatedPicklistMapping));
    } catch (e) {
      logUtils.logError(e, 'Updating Picklist Mapping failed');
      throw e;
    } finally {
      dispatch(setFormLoader(false));
    }
  };
}

export function createPicklistMapping(picklistMapping) {
  return async (dispatch) => {
    dispatch(setFormLoader(true));
    try {
      delete picklistMapping.id;
      const createdPicklistMapping = await ApiService.upsertPicklistMapping(picklistMapping);
      if (!createdPicklistMapping) throw new Error('Picklist Mapping not created');
      toastr.success('Picklist Mapping Created');
      dispatch(upsertPicklistMapping(createdPicklistMapping));
    } catch (e) {
      logUtils.logError(e, 'Picklist Mapping creation failed');
      throw e;
    } finally {
      dispatch(setFormLoader(false));
    }
  };
}

export function onSubmitButtonClicked(picklistMapping) {
  return async (dispatch) => {
    const clonedPicklistMapping = _.clone(picklistMapping);
    if (!clonedPicklistMapping.xid) {
      clonedPicklistMapping.xid = clonedPicklistMapping.name;
    }
    if (picklistMapping.id) {
      await updatePicklistMapping(clonedPicklistMapping)(dispatch);
    } else {
      await createPicklistMapping(clonedPicklistMapping)(dispatch);
    }
  };
}

export function deletePicklistMapping(picklistMapping) {
  return async (dispatch) => {
    dispatch(setLoader(true));
    const clonedPicklistMapping = _.clone(picklistMapping);
    clonedPicklistMapping.isDeleted = true;
    try {
      const deletedPicklistMapping = await ApiService.upsertPicklistMapping(clonedPicklistMapping);
      dispatch(deletePicklistFromRedux(deletedPicklistMapping));
      toastr.success('Picklist Mapping Deleted');
    } catch (e) {
      logUtils.logError(e, 'Picklist Mapping deleting failed');
    } finally {
      dispatch(setLoader(false));
    }
  };
}
